import { clearUserStorage } from "./reset-user-state";
import { getStoredTable } from "@/atoms/table";

export default function removeProfileToken() {
  const tableId =
    new URLSearchParams(window.location.search).get("table") ??
    getStoredTable()?.id ??
    null;

  clearUserStorage();

  window.location.href = tableId
    ? `/profile/auth?table=${encodeURIComponent(tableId)}`
    : "/profile/auth";
}
